/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 11:31 AM
 */
import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button, Form, Icon, Input} from "semantic-ui-react";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import Lbl from "../../../../components/Label/Lbl";
import './AddCorporateAdmin.css'
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as EmailValidator from "email-validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";
import * as dropDownConst from '../../../../store/Reducer/DropDownConst';
import IntlTelInput from "react-intl-tel-input";

class App extends Component {
  state = {
    completeCorporateAdmin: null,
    mobile: '',
    format_mobile:'',
    valid_mobile: false,
    corporates_list: [],
    email: "",
    name: "",
    username: "",
    password: "",
    corporateId: "",
    userRole: "",
    validatePassword: false
  };

  handleCorporateChange = (e, {value}) => {
    this.setState({
      corporateId: value
    });
  };

  handleUserRoleChange = (e, {value}) => {
    this.setState({
      userRole: value
    });
  };

  handleChange = name => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }

  };

  getAllCorporate = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            corporates_list: response.data.corporateList
          })
        } else {
          this.setState({
            corporates_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCorporate()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  createCorAdmin = () => {

    const {email, name, username, corporateId, valid_mobile} = this.state;
    if (email.trim() === "" || name.trim() === "" || username.trim() === "" || corporateId === "") {
      common.notifyMessage("Please enter all required fields");
    } else {
      if (!valid_mobile) {
        common.notifyMessage("Invalid mobile number");
        return;
      }
      let validateEmail = EmailValidator.validate(email);
      if (validateEmail) {
        if (this.state.validatePassword) {
          swal({
            title: "Do you want to create corporate admin?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Yes",
                value: "action",
                className: "okay-btn"
              }
            },
          })
            .then((value) => {
              switch (value) {
                case "action":
                  this.sendToBackend();
                  break;
                default:
              }
            });
        } else {
          common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS");
        }
      } else {
        common.notifyMessage("Please enter valid email address");
      }
    }
  };
  sendToBackend = () => {
    const {email, name, username, corporateId, password, userRole, format_mobile} = this.state;
    const obj = {
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": 1,
      "userRoles": userRole,
      "branchId": [],
      "mobile": format_mobile
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.CORPORATE_SELECT_SYSTEM_USER(corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Corporate admin successfully created - (" + username + ")", 0);
          this.clearFeilds()
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };
  clearFeilds = () => {
    this.setState({
      email: "", name: "", username: "", password: "", validatePassword: false, mobile: '', format_mobile:'', valid_mobile: false,
    })
  };
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };

  componentDidMount() {
    this.getAllCorporate();
  }

  render() {
    let corporates_list = this.state.corporates_list;
    let corporates_options = [];
    if (corporates_list.length !== 0) {
      corporates_list.map((cor, index) => {
        const obj = {
          key: index,
          text: cor.corporateName,
          value: cor.corporateId,
          // image: {avatar: true, src: cor.photoPath},
        };
        corporates_options.push(obj)
      })
    }

    return (
      <div>
        <Row>
          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
              <CardHeader>
                CORPORATE ADMIN DETAILS
              </CardHeader>
              <CardBody>

                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Email"}
                      placeholder={"Email"}
                      value={this.state.email}
                      onChange={this.handleChange('email')}
                    />

                  </Form.Group>

                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Full Name"}
                      placeholder={"Full name"}
                      value={this.state.name}
                      onChange={this.handleChange('name')}
                    />
                  </Form.Group>

                  <div>
                    <Lbl required style={{marginTop: '0px!important'}}>Mobile Number</Lbl>
                    <IntlTelInput
                      type={"text"}
                      fieldName={"Mobile Number"}
                      style={{width: '100%', height: '37px'}}
                      value={this.state.mobile}
                      containerClassName="intl-tel-input dashboard-intl"
                      inputClassName="form-control"
                      onPhoneNumberChange={this.onPhoneNumberChange}
                      required={true}
                      preferredCountries={['lk']}
                      defaultCountry={"lk"}
                      nationalMode={false}
                    />
                  </div>
                </Form>
                <br/>

                <Form.Group widths='equal'>
                  <Lbl required>Join Corporate</Lbl>
                  <LabelDropdown
                    noneLable
                    required
                    options={corporates_options}
                    placeholder={"Choose Corporate"}
                    onChange={this.handleCorporateChange}
                  />
                  {/*<DrpDwn*/}
                  {/*// tagText={"Join Corporate"}*/}
                  {/*placeholder={"Choose Corporate"}*/}
                  {/*// value={this.state.country}*/}
                  {/*// options={countries_list}*/}
                  {/*// onChange={this.countryOnChange}*/}
                  {/*/>*/}

                </Form.Group>

                <Form.Group widths='equal'>
                  <Lbl required>Select User Role</Lbl>
                  <LabelDropdown
                    noneLable
                    required
                    options={dropDownConst.corporateAdminRoles}
                    placeholder={"Choose User Role"}
                    onChange={this.handleUserRoleChange}
                  />
                </Form.Group>

              </CardBody>
            </Card>
          </Col>

          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
              <CardHeader>
                CREDENTIALS
              </CardHeader>
              <CardBody>

                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Username"}
                      placeholder={"Username"}
                      value={this.state.username}
                      onChange={this.handleChange('username')}
                    />

                  </Form.Group>

                  <Col className={"none-padding"} lg={12}>
                    <Lbl required>Password</Lbl>
                    <Input id={"password-field"} type={"password"}
                           onChange={this.handleChange('password')}
                           value={this.state.password}
                           style={{width: '100%'}}
                           icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                       onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                           placeholder='Password'/>
                  </Col>
                </Form>

              </CardBody>
            </Card>
          </Col>

          <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
            <Button className="px-5" onClick={this.createCorAdmin}>Create Corporate Admin</Button>
          </Col>

        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
